import { cn } from "@/lib/utils";
import { Card } from "./card";
import { RollingText } from "./rolling-text";

export function MetricCard({
  label,
  value,
  format,
  delta,
  hint,
  className,
}: {
  label: string;
  /** null while it is not known yet: shown as a dash. */
  value: number | null;
  format?: Intl.NumberFormatOptions;
  delta?: { value: number; label: string };
  hint?: string;
  className?: string;
}) {
  const text = value === null ? "–" : new Intl.NumberFormat("en-US", format).format(value);
  const rising = (delta?.value ?? 0) >= 0;
  const deltaText = delta
    ? `${delta.value > 0 ? "+" : ""}${new Intl.NumberFormat("en-US", {
        style: "percent",
        maximumFractionDigits: 1,
        signDisplay: "never",
      }).format(delta.value)}`
    : null;

  return (
    <Card className={cn("px-5 py-4", className)} data-slot="metric-card">
      <p className="text-sm text-secondary">{label}</p>
      <p className="mt-3 font-display text-3xl tracking-[-0.03em] text-foreground">
        <RollingText text={text} />
        <span className="sr-only">{text}</span>
      </p>
      {delta && deltaText ? (
        <p className="mt-3 flex items-baseline gap-2 text-sm">
          <span className={rising ? "text-success" : "text-danger"}>
            <RollingText text={deltaText} />
            <span className="sr-only">{deltaText}</span>
          </span>
          <span className="text-muted">{delta.label}</span>
        </p>
      ) : null}
      {hint ? <p className="mt-2 text-sm text-muted">{hint}</p> : null}
    </Card>
  );
}
